import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const Kelurahan = ({ id }) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [kelurahan, setKelurahan] = useState('')

    useEffect(() => {
        const getKelurahan = async () => {
            try {
                const response = await masterService.getKelurahanById(id)
                setKelurahan(response.data.uraianKel)
            } catch (error) {
                setKelurahan('')
            }
        }
        getKelurahan()
    }, [masterService, id])

    return (
        <>
            {kelurahan}
        </>
    )
}

export default Kelurahan